@if (!minimized) {
  <div class="panel">
    <div class="border-b border-gray-200">
      <div class="px-8 h-20 items-center flex gap-3" [class.assigned-list-header]="sidebarFilter === 'assigned_to_me'">
        <div class="text-[13px] font-medium tracking-[0.3px] text-headline whitespace-nowrap overflow-hidden text-ellipsis">
          {{ sidebarFilter | titleByNotesFilter: containerName: true }}
          @if (isAdvancedSearchApplied() && sidebarFilter !== 'assigned_to_me') {
            – Search Results
          }
        </div>
        <div class="grow"></div>
        <!-- [MUST-003] 'Debug' button hidden per task; uncomment to re-enable
        <div
          class="debug"
          [class.active]="debug"
          (click)="doDebug()"
          >
          {{ debug || 'Debug' }}
        </div>
        -->
        @if (selectedTab === 'notes') {
          <app-context-menu-state-indicator
            svgIcon="filters"
            appNotesListContextMenu
            [appNotesListContextMenuWithAdvancedSearch]="sidebarFilter !== 'assigned_to_me'"
            />
        }
        @if (selectedTab === 'notebooks') {
          <app-context-menu-state-indicator
            svgIcon="filters"
            appNotebooksListContextMenu
            [appNotebooksListContextMenuWithAdvancedSearch]="true"
            />
        }
      </div>
      @if (listState === 'tabs') {
        <app-tabs
          class="panel-heading-tabs"
          [values]="tabs"
          [value]="selectedTab"
          (valueChange)="handleSelectedTabChange($event)"
          />
      }
    </div>
        <div class="panel-list" [class.assigned-panel-list]="sidebarFilter === 'assigned_to_me'">
          <!-- `notesFilters` is that tuple's product, and the tenant gate withholds it until the member
               tenant is known (#1065 ROW 1). Binding `undefined` OVERWRITES the list's own `= {}` default
               and `getSection` then reads `filters.followedOnTop` off it — a TypeError on every
               legacy-null reload, measured 3/3. Mail's container has carried this guard since #1049. -->
          @if (sidebarFilter === 'assigned_to_me' && notesFilters) {
            <app-note-assigned-list
              [filters]="notesFilters"
              (openNote)="handleClickNote($event)"
              (doubleClickNote)="handleDoubleClickNote($event)"
            />
          } @else if (selectedTab === 'notes' && notesFilters) {
            <app-notes-list
              [openOnRemoval]="false"
              [filters]="notesFilters"
              [debug]="debug"
              [showLocationBadge]="isAdvancedSearchApplied()"
              (loadInProgress)="loading = $event"
              (openNote)="handleClickNote($event)"
              (clickNote)="handleClickNote($event)"
              (doubleClickNote)="handleDoubleClickNote($event)"
              />
          }
          @if (selectedTab === 'notebooks' && notebooksFilters) {
            <app-notebooks-list
              [filters]="notebooksFilters"
              [debug]="debug"
              (loadInProgress)="loading = $event"
              (openNotebook)="handleClickNotebook($event)"
              (openNote)="handleClickNote($event)"
              (clickNotebook)="handleClickNotebook($event)"
              (doubleClickNotebook)="handleDoubleClickNotebook($event)"
              />
          }
        </div>
      </div>
    }
